import { IsInt, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class RejectOperationDto {
  @IsInt()
  @IsNotEmpty()
  managerEmployeeId: number;

  @IsString()
  @IsOptional()
  @MaxLength(500, { message: 'Note is too long. Maximum is 500 characters.' })
  note?: string;
}